export default __webpack_public_path__ + "static/media/ic_history.70631641.svg";